import React from 'react';
import { PaywallAwareButton } from '../components/PaywallAwareButton';
import { DuoSquareDashedCirclePlusIcon } from '../theme/Icons';
import { useBreakpoints } from '../theme/useBreakpoints';

interface AddTaskButtonProps {
    onClick: () => void;
    useIcon?: boolean;
    canAdd?: boolean;
    iconOnly?: boolean;
}

export const AddTaskButton: React.FC<AddTaskButtonProps> = ({ onClick, useIcon = false, canAdd = true, iconOnly = false }) => {
    const { isBelowBreakpoint } = useBreakpoints();
    const label = isBelowBreakpoint('sm') ? 'Add Task' : 'Add Task';

    if (!canAdd) {
        return null;
    }

    return (
        <PaywallAwareButton
            fill={useIcon ? 'clear' : 'solid'}
            color="primary"
            triggerSource="menu add appointment"
            data-id="add-task-button"
            requiresInnerhivePlus={() => false} // Tasks don't require plus for now
            onClick={onClick}
            expand={useIcon ? undefined : 'block'}
        >
            {useIcon ? <DuoSquareDashedCirclePlusIcon /> : '+'}
            {!iconOnly && (
                <>&nbsp;{label}</>
            )}
        </PaywallAwareButton>
    );
};
